const SET_ALARM_FLAG = 'notice/SET_ALARM_FLAG';

export default {
  SET_ALARM_FLAG
}



// WEBPACK FOOTER //
// ./src/actions/noticeTypes.js